import { useMutation, useQueryClient } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Organization } from "../../types/api/User";
import { useNavigate } from "react-router-dom";

interface CreateOrgBody {
  selected_type: string;
  name: string;
}

export default () => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation<Organization, null, CreateOrgBody>(
    `org_create`,
    async (body: CreateOrgBody) =>
      Post(`/api/organization`, await getAccessTokenSilently(), body),
    {
      onSuccess: (org) => {
        queryClient.invalidateQueries([`user`]);

        // Check for invite_org_id in localStorage first
        const inviteOrgId = localStorage.getItem('invite_org_id');
        if (inviteOrgId) {
          console.log("redirecting to invited storefront after org creation", inviteOrgId);
          navigate(`/storefront/${inviteOrgId}`);
          // Clear the invite_org_id from localStorage after redirecting
          localStorage.removeItem('invite_org_id');
        } else {
          navigate(`/app/${org.id}/welcome`);
        }
      },
    }
  );
};
